import { Box, Typography } from "@mui/material";
import { formatSeconds } from "../../../store/formatUtil";

export const EditorDAWTimeDisplay = ({ label, value }) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography lineHeight={1} variant="overline">
        <span style={{ fontWeight: 500, marginRight: 4 }}>{label}:</span>
        {formatSeconds(value)}
      </Typography>
    </Box>
  );
};
